export const ROLES = {
  MEMBER: "member",
  TREASURER: "treasurer",
  ADMIN: "admin",
};

export function isAdmin(user) {
  return ["admin", "treasurer"].includes(user?.role);
}

export function canAccess(user, rolesAllowed) {
  if (!rolesAllowed || rolesAllowed.length === 0) return true;
  return rolesAllowed.includes(user?.role);
}
